// extracted by mini-css-extract-plugin
export default {"auth_container":"style_auth_container__EaLhu","auth_form":"style_auth_form__BNKdl","form_control":"style_form_control__YY9Xg","button":"style_button__mLTjL"};